// Shared utility functions to prevent circular dependencies

// iOS/WKWebView-safe external link opener
export function openExternalLink(url) {
    if (!url) return;
    if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
    try {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.position = 'fixed';
        link.style.left = '-9999px';
        link.style.top = '-9999px';
        link.style.width = '1px';
        link.style.height = '1px';
        link.style.opacity = '0';
        link.style.pointerEvents = 'none';
        document.body.appendChild(link);
        link.click();
        setTimeout(function () { if (link.parentNode) link.parentNode.removeChild(link); }, 0);
    } catch (e) {
        try { window.open(url, '_blank', 'noopener,noreferrer'); } catch (e2) { console.error('openExternalLink failed:', e2); }
    }
}

// Helper to convert VAPID public key
export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

// Helper for comma formatting
export function formatNumberWithCommas(value) {
    if (value === null || value === undefined || value === '') return '';
    const stringValue = value.toString().replace(/[^0-9.]/g, '');
    const parts = stringValue.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (parts.length > 1) {
        return parts[0] + '.' + parts[1].substring(0, 2);
    }
    return parts[0] + (value.toString().endsWith('.') ? '.' : '');
}

// Route same-origin image paths through the GD optimization proxy
// (/api/image.php). External URLs and data URIs are returned unchanged.
export function optimizeImageSrc(src, width) {
    if (!src) return src;
    if (/^(https?:|data:|blob:)/i.test(src)) return src;
    const w = Math.max(50, Math.min(2000, parseInt(width, 10) || 400));
    return '/api/image.php?path=' + encodeURIComponent(src) + '&w=' + w;
}

// Helper to check if a URL is valid
export function isValidUrl(url) {
    if (!url) return false;
    try {
        new URL(url, window.location.origin);
        return true;
    } catch (e) {
        return false;
    }
}

// Helper to log to file
export async function logToFile(message) {
    // Make sure we use .js for MIME content-type
    try {
        await fetch('/api/log.php', { method: 'POST', body: message });
    } catch (e) {
        console.error("Could not write to file!", e);
    }
}

// Rebuild classifications for equipment rebuilds
export const REBUILD_CLASSIFICATIONS = [
    { id: 'A', title: 'Category A: Fully Rebuilt / Ready for Sale', desc: 'This machine has been fully rebuilt to OEM or better standards and is ready for immediate deployment.', icon: 'fas fa-check-circle text-green-500', badgeClasses: 'bg-green-50 border-green-200', titleColor: 'text-green-800', descColor: 'text-green-700' },
    { id: 'B', title: 'Category B: Partially Rebuilt / Needs Minor Work', desc: 'This machine has been partially rebuilt and requires minor work before it is ready for deployment.', icon: 'fas fa-wrench text-yellow-500', badgeClasses: 'bg-yellow-50 border-yellow-200', titleColor: 'text-yellow-800', descColor: 'text-yellow-700' },
    { id: 'C', title: 'Category C: Stripped for Parts / Not Operational', desc: 'This machine is not operational and is being sold for parts or scrap.', icon: 'fas fa-exclamation-triangle text-red-500', badgeClasses: 'bg-red-50 border-red-200', titleColor: 'text-red-800', descColor: 'text-red-700' }
];
